<template>
    <div class="babel-header-template">
        <Section>
            <div class="top-describe">
                <div class="describe-left">
                    <div class="des-top">
                        <b>{{title}}</b>
                    </div>
                    <div class="des-bom">{{remark}}</div>
                </div>
            </div>
        </Section>
        <!--<Section :title="标题">
            <div style="padding: 20px">车位锁</div>
        </Section>-->
        <Section>
            <FilterBox :item-right="40" inline border style="padding: 10px;">
                <FilterBoxItem style="margin-right: 20px">
                    <Input  placeholder="搜索卡券标题" v-model="searchText" style="width: 200px" />
                </FilterBoxItem>

                <FilterBoxItem style="margin-right: 20px">
                    <Select  style="width: 130px" v-model="searchCardType">
                        <Option v-for="item in cardTypeList" :value="item.value">{{item.name}}</Option>
                    </Select>
                </FilterBoxItem>

                <FilterBoxItem>
                    <Button type="primary" @click="search">查找</Button>
                </FilterBoxItem>

                <FilterBoxItem style="margin-right: 20px">
                    <div class="clear-search" @click="clearSearch">
                        <Icon  type="md-close-circle" :size="18" color="#bfbfbf"/>
                        <span>清空筛选</span>
                    </div>
                </FilterBoxItem>

                <FilterBoxItem style="float: right;">
                    <Button style="margin: 0px 5px" v-if="cardActivityStatus" type="warning" @click="setCardActivityStatus('off')">关闭活动卡券</Button>
                    <Button style="margin: 0px 5px" v-if="!cardActivityStatus" type="warning" @click="setCardActivityStatus('open')">开启活动卡券</Button>
                </FilterBoxItem>

            </FilterBox>

            <LabelHeader style="padding-top: 10px;">

                <div slot="before">
                    <span class="fs-12px colorA3 mr-10px">列表(共<font color="#307deb">{{tabledata.length}}</font>条, 筛选<font color="#307deb">{{selectdata.length}}</font>条)</span>
                    <Button style="margin: 0px 5px" type="error" @click="delModal=true" >删除</Button>
                </div>

                <div slot="after">
                    <Button style="margin: 0px 5px" type="primary"  @click="syncModal = true">同步卡券</Button>
                    <Button style="margin: 0px 5px" type="primary" @click="WeChatCardModal=true">微信卡券</Button>
                </div>

            </LabelHeader>

            <div style="padding: 20px">
                <Table border :columns="columns" @on-selection-change="onSelectionChange" :data="tabledata" :loading="loading"></Table>
            </div>


            <!--微信卡券-->
            <WeChatCard :modal="WeChatCardModal"  :onCancel="weChatCardOnCancel" :width="1200" ></WeChatCard>


            <!--开启抽奖-->
            <Modal v-model="OpenLuckDrawModal"  width="340">
                <div slot="header">
                    <b>开启抽奖</b>
                </div>
                <div>
                    <Checkbox :true-value="1" :false-value="0" v-model="luckyDrawShowHome" style="margin:10px 0px 10px 100px;">&nbsp;&nbsp;&nbsp;首页展示</Checkbox>
                </div>
                <div slot="footer">
                    <Button  @click="OpenLuckDrawModal=false">取消</Button>
                    <Button  type="primary" :loading="loading" @click="setLuckyDrawOpen('open')">开启</Button>
                </div>
            </Modal>

            <!--编辑-->
            <Modal v-model="EditorModal" class-name='vertical-center-modal' width="400">
                <div slot="header">
                    <b>编辑标题</b>
                </div>
                <div class="pt-10px">
                    <Form :label-width="100" ref="formValidateTitle" :model="formValidateTitle" :rules="ruleValidate">
                        <FormItem prop="title">
                            <span slot='label' class="color-666 mr-10px">标题</span>
                            <Input v-model="formValidateTitle.title" :maxlength="50" placeholder="请填写前端展示标题" style="width: 220px;" />
                            <span class="color-999 ml-10px">{{formValidateTitle.title.trim().length}}/50</span> <!--<br>-->
                            <!--<span style="color: #ed4014;">#代表前端展示换行,如:10元#代金券</span>-->
                        </FormItem>
                    </Form>
                </div>

                <div slot="footer">
                    <Button  @click="EditorModal=false">取消</Button>
                    <Button  type="primary" :loading="loading" @click="editorSubmit">确认</Button>
                </div>
            </Modal>


            <!--关闭确认框-->
            <Modal v-model="offModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#f44336" /><span style="color: #f44336">关闭确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">关闭后,此活动卡券将不再参与店铺中显示。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: red">关闭</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="offModal=false">取消</Button>
                    <Button  :loading="loading" type="error" @click="off" >确认关闭</Button>
                </div>
            </Modal>


            <!--开启确认框-->
            <Modal v-model="openModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#3384f7" /><span style="color: #3384f7">开启确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">开启后,此活动卡券将再参与店铺中显示。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color:#3384f7">开启</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="openModal=false">取消</Button>
                    <Button  :loading="loading" type="primary" @click="open" >确认开启</Button>
                </div>
            </Modal>


            <!--删除确认框-->
            <Modal v-model="delModal" id="delModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#f44336" /><span style="color: #f44336">删除确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">删除后,列表未达到6列将默认关闭抽奖。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: red">删除</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="delModal=false">取消</Button>
                    <Button  :loading="loading" type="error" @click="del" >确认删除</Button>
                </div>
            </Modal>


            <!--同步确认框-->
            <Modal v-model="syncModal" id="syncModal" class-name='vertical-center-modal' width="500">
                <div slot="header">
                    <b><Icon type="ios-alert" style="color:#ff9900" /><span style="color: #ff9900">同步确认</span></b>
                </div>
                <div class="pt-10px">
                    <div slot='label' class="color-666 mr-20px" style="text-align: center;padding: 20px">同步微信卡券所需时间可能较长。</div>
                    <div slot='label' class="color-666 mr-10px" style="text-align: center;padding-bottom: 20px">是否继续 <label style="color: #ff9900">同步</label>？</div>
                </div>
                <div slot="footer">
                    <Button  type="default" @click="syncModal=false">取消</Button>
                    <Button  :loading="loading" type="warning" @click="synchronousCard" >同步</Button>
                </div>
            </Modal>


        </Section>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'
    import FilterBox from '@/modules/FilterBox';
    import FilterBoxItem from '@/modules/FilterBoxItem';
    import menuUtil from '../../../utils/menu-list.js';
    import Qs from 'qs';
    import WeChatCard from './WeChatCard';

    import { Table, Page, Button, Input, Select, Checkbox, Option, Modal , InputNumber, Form ,FormItem, AutoComplete,Icon, Spin} from 'iview';
    import IForm from "iview/src/components/form/form";

    export default {
        name: "CardActivity",
        components: {
            WeChatCard,
            Checkbox,
            IForm,
            LabelHeader,
            FilterBox,
            FilterBoxItem,
            Table,
            Button,
            Page,
            Input,
            Select,
            Option,
            Modal,
            Form,
            FormItem,
            InputNumber,
            AutoComplete,
            Icon,
            Spin
        },
        data () {
            return {
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '卡券类型',
                        key: 'cardType',
                        align: 'center',
                        maxWidth: 160,
                        render: (h, params) => {
                            let text = "";
                            switch(params.row.cardType) {
                                case "DISCOUNT":
                                    text = "折扣券";
                                    break;
                                case "GIFT":
                                    text = "礼品券";
                                    break;
                                case "GROUPON":
                                    text = "团购券";
                                    break;
                                case "CASH":
                                    text = "代金券";
                                    break;
                                case "GENERAL_COUPON":
                                    text = "通用券";
                                    break;
                                default:
                                    text = "其他券";
                            }
                            return h('span', {style:{color:"#FF3300"}}, text)
                        }
                    },
                    {
                        title: '现库存量',
                        key: 'quantity',
                        align: 'center',
                        maxWidth: 120
                    },
                    {
                        title: '标题',
                        key: 'title',
                        align: 'center',
                        minWidth: 160
                    },
                    {
                        title: '商户名',
                        key: 'brandName',
                        align: 'center',
                        minWidth: 160
                    },
                    {
                        title: '操作',
                        align: 'center',
                        width: 240,
                        render: (h, params) => {
                            let btnStyle = "padding:0 10px;";
                            var buttons = [];
                            buttons.push(h('a', {style: btnStyle, on: {
                                    click: () => {
                                        this.formValidateTitle.title = params.row.title?params.row.title:"";
                                        this.formValidateTitle.id = params.row.id;
                                        this.loading = false;
                                        this.EditorModal = true;
                                    }
                                }}, '编辑标题'));

                            buttons.push(h('a', {style: btnStyle, on: {
                                    click: () => {
                                        this.$parent.cardId = params.row.cardId;
                                        this.$parent.JoinModal = true;
                                        this.$parent.title = params.row.title;
                                    }
                                }}, '参与店铺'));

                            if (params.row.activityOpen){
                                buttons.push(h('a', {style: btnStyle + "color:#f44336", on: {
                                        click: () => {
                                            this.ID = params.row.id;
                                            this.offModal = true
                                        }
                                    }}, '关闭'));
                            }else {
                                buttons.push(h('a', {style: btnStyle, on: {
                                        click: () => {
                                            this.ID = params.row.id;
                                            this.openModal = true
                                        }
                                    }}, '开启'));
                            }


                            return h('div',buttons);
                        }
                    }
                ],

                luckyDrawShowHome:0,//展示首页

                formValidateTitle: {
                    title:'',
                },

                ruleValidate: {
                    lotteryNumber:[
                        {required:true, type:"number", message:'请输入抽奖次数',trigger: 'blur'}
                    ],
                    title: [
                        {required:true, message: '标题不能为空', trigger: 'blur' }
                    ]
                },

                menuName:"",
                remark:"",
                title:"",

                OpenLuckDrawModal:false,

                tabledata: [],  //列表展示数据
                resultdata:[],  //请求返回总数数据
                selectdata:[],

                cardTypeList:[
                    {name:"折扣券",value:"DISCOUNT"},
                    {name:"礼品券",value:"GIFT"},
                    {name:"团购券",value:"GROUPON"},
                    {name:"代金券",value:"CASH"},
                    {name:"卡券类型-全部",value:"all"},
                    ],

                loading:false, //加载状态

                //检索条件
                searchText:"",//查询条件文本
                searchCardType:"all",

                pageSize: 15, //每页展示数量
                WeChatCardModal:false,//微信卡券
                delModal:false,//删除Modal
                syncModal:false,//同步Modal
                offModal:false,
                openModal:false,
                EditorModal:false,//编辑
                cardActivityStatus:0,  //开关状态
                ID:null,//当前操作行的ID

            }

        },
        methods: {

            //查询所有记录
            request() {
                this.loading = true;
                this.$request.get(`${this.$HOST}/back/cardActivity`,).then((res)=>{
                    this.loading = false;
                    if (!res.data.code && res.data.result) {
                        console.log(res.data.result);
                        this.tabledata = res.data.result;
                        this.resultdata = res.data.result;
                    }
                });

                this.querySettings();
            },

            getOffsetCount (page){
                if (!page) page = 1;
                return {offset:(page-1)*this.pageSize,count:this.pageSize};
            },

            pageOnChange (page){
                this.request(page);
            },


            /**
             * 检索事件
             */
            search (){
                this.loading = true;
                let array = [];
                if (this.searchText.trim().length){
                    array = this.resultdata.filter((item)=>{
                        return item.title.indexOf(this.searchText)!==-1;
                    })
                }else array = this.resultdata;

                if (this.searchCardType!=="all")
                {
                    array = array.filter((item)=>{
                        return item.cardType === this.searchCardType;
                    });
                }
                this.tabledata = array;
                this.loading = false;
            },

            off (){
                if (this.loading) return;
                this.loading = true;
                this.$request.get("/back/cardActivity/off/"+this.ID,{baseURL:this.$HOST}).then((res)=>{
                    this.loading = false;
                    if (!res.data.code)
                        this.offModal = false;
                    else
                        this.$Message(res.data.message);
                    this.request();
                })
            },

            open (){
                if (this.loading) return;
                this.loading = true;
                this.$request.get("/back/cardActivity/open/"+this.ID,{baseURL:this.$HOST}).then((res)=>{
                    this.loading = true;
                    if (!res.data.code)
                        this.openModal = false;
                    else
                        this.$Message(res.data.message);
                    this.request();
                })
            },

            setCardActivityStatus (status){
                if (this.loading) return;
                this.loading = true;
                let apiUrl = "/back/cardActivity/"+status;
                this.$request.get(apiUrl,{baseURL:this.$HOST}).then((res)=>{
                    this.loading = true;
                    if (res.data.code) this.$Message(res.data.message);
                    this.request();
                })
            },


            // 输入框改变事件
            _textChange(text) {

                this.findByCond();
            },


            onSelectionChange(cell){
                this.selectdata = cell;
            },


            /**
             * 查询抽奖次数
             */
            querySettings (){
                this.$request.get("/back/setting",{baseURL:this.$HOST}).then((res)=>{
                    if (!res.data.code && res.data.result){
                        this.cardActivityStatus = res.data.result.cardActivityOpen;
                    }else  this.$Message(res.data.message);
                })
            },

            editorSubmit (){
                this.$refs["formValidateTitle"].validate((valid) => {
                    if (valid){
                        if (this.loading) return;
                        this.loading = true;
                        let obj = {
                            id:this.formValidateTitle.id,
                            title:this.formValidateTitle.title
                        }
                        this.$request.put("/back/cardActivity",obj,{baseURL:this.$HOST}).then((res)=>{
                            this.loading = false;
                            if (!res.data.code && res.data.result){
                                this.$Message.success("保存成功!");
                                this.EditorModal = false;
                            }else this.$Message(res.data.message);
                            this.request();
                        })
                    }
                });
            },

            /**
             * 清空筛选
             */
            clearSearch (){
                this.searchText = "";
                this.searchCardType = "all";
                this.request();
            },


            weChatCardOnCancel (){
                this.WeChatCardModal = false;
                this.request();
            },

            /**
             * 设置抽奖开关状态
             */
            setLuckyDrawOpen (type){

                if (this.loading) return;
                this.loading = true;

                let apiUrl = "/back/luckyDraw/"+type;
                if ('open'===type) {
                    apiUrl +="?show="+ this.luckyDrawShowHome;
                }
                this.$request.put(apiUrl,null,{baseURL:this.$HOST}).then((res)=>{
                    this.loading = false;
                    if (!res.data.code)
                        this.request();
                    else
                        this.$Message.error(res.data.message);
                    this.OpenLuckDrawModal = false;
                })
            },

            openLuckDraw (){
                this.$request.get("/back/setting",{baseURL:this.$HOST}).then((res)=>{
                    if (!res.data.code && res.data.result){
                        this.luckyDrawShowHome =  res.data.result.luckyDrawShowHome;
                        this.OpenLuckDrawModal = true;
                    }else  this.$Message(res.data.message);
                })
            },

            /**
             * 删除卡券
             */
            del (){

                let cardIds = [];

                if (this.selectdata && this.selectdata.length){
                    this.selectdata.forEach((item)=>{
                        cardIds.push(item.cardId);
                    })
                }

                if (!cardIds.length){
                    this.$Message.error("请选择数据");
                    return;
                }

                if (!this.loading){
                    this.loading = true;
                    this.$request.delete("/back/cardActivity",{baseURL:this.$HOST,params:{cardIds:cardIds},paramsSerializer: params => {
                            return Qs.stringify(params, { indices: false })
                        }}).then((res)=>{
                        this.loading = false;
                        if (!res.data.code){
                            this.delModal = false;
                            this.request();
                        } else this.$Message.error(res.data.message);
                    })
                }
            },

            /**
             * 同步微信卡券
             */
            synchronousCard (){
                if (this.loading) return;
                this.loading = true;
                this.$request.get("/back/cardActivity/synchronousCard",{baseURL:this.$HOST}).then((res)=>{
                    this.loading = false;
                    if (!res.data.code){
                        this.syncModal = false;
                        this.request();
                    } else this.$Message.error(res.data.message);
                })
            }
        },

        created(){
            this.request();
        },

        mounted () {
            let menuObj = menuUtil.getRemark(this.$router.history.current.path);
            this.title = menuObj.menuName;
            this.remark = menuObj.remark;
        },
    }
</script>

<style lang="less" scoped>
    @import '../../../styles/mainTop';
    .clear-search{
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        vertical-align: middle;
    i{
        display: inline-block;
        line-height: 30px;
    }
    span{
        vertical-align: middle;
        margin-left: 3px;
    }
    }
</style>
